import { c as _c } from "react/compiler-runtime";
import { PasswordCardPropertiesType } from "@website/widget/login/components/password-card/password-card.types";
import { AuthByPasswordService } from "@website/widget/login/services/auth-by-password";
import { AuthRequestOtpService } from "@website/widget/login/services/auth-request-otp";
import { ResetPasswordRequestOtpService } from "@website/widget/login/services/reset-password-request-otp";
import { isPhoneNumberValid } from "@website/widget/login/utils";
import { useState } from "react";
export const usePasswordCard = properties => {
  const $ = _c(25);
  const {
    userData,
    setStep,
    setUserData,
    onEndAuth
  } = properties;
  const [isLoadingPassword, setIsLoadingPassword] = useState(false);
  const [isLoadingOtp, setIsLoadingOtp] = useState(false);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = value => {
      setPassword(value);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onChangePassword = t0;
  let t1;
  if ($[1] !== onEndAuth || $[2] !== password || $[3] !== setUserData || $[4] !== userData) {
    t1 = async _event => {
      _event.preventDefault();
      if (password) {
        setIsLoadingPassword(true);
        setError("");
        AuthByPasswordService({
          phoneNumber: userData?.phoneNumber,
          password
        }).then(data => {
          const {
            accessToken,
            refreshToken
          } = data;
          if (accessToken) {
            setUserData({
              ...userData,
              ...data
            });
            onEndAuth?.(accessToken, refreshToken);
          }
        }).catch(error_0 => {
          setError(error_0?.response?.message || "\u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F\u0647 \u0627\u0633\u062A \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.");
        }).finally(() => setIsLoadingPassword(false));
      } else {
        setError("\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u062E\u0648\u062F \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.");
      }
    };
    $[1] = onEndAuth;
    $[2] = password;
    $[3] = setUserData;
    $[4] = userData;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onSubmitPassword = t1;
  let t2;
  if ($[6] !== setStep || $[7] !== setUserData || $[8] !== userData) {
    t2 = async () => {
      const {
        phoneNumber
      } = userData;
      if (isPhoneNumberValid(phoneNumber)) {
        setIsLoadingOtp(true);
        setError("");
        AuthRequestOtpService({
          phoneNumber
        }).then(data_0 => {
          setStep("otp");
          setUserData({
            ...userData,
            ...data_0
          });
        }).catch(error_1 => {
          setError(error_1?.response?.data?.message || "\u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F\u0647\u060C \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.");
        }).finally(() => setIsLoadingOtp(false));
      }
    };
    $[6] = setStep;
    $[7] = setUserData;
    $[8] = userData;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const onOtpClick = t2;
  let t3;
  if ($[10] !== setStep || $[11] !== setUserData || $[12] !== userData) {
    t3 = async () => {
      const {
        phoneNumber: phoneNumber_0
      } = userData;
      if (isPhoneNumberValid(phoneNumber_0)) {
        setIsLoadingOtp(true);
        setError("");
        ResetPasswordRequestOtpService({
          phoneNumber: phoneNumber_0
        }).then(data_1 => {
          setUserData({
            ...userData,
            ...data_1,
            forgotPassword: true
          });
          setStep("otp");
        }).catch(error_2 => {
          setError(error_2?.response?.data?.message || "\u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F\u0647\u060C \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.");
        }).finally(() => setIsLoadingOtp(false));
      }
    };
    $[10] = setStep;
    $[11] = setUserData;
    $[12] = userData;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const onClickForgotPassword = t3;
  let t4;
  if ($[14] !== setStep) {
    t4 = () => {
      setStep("phone-number");
    };
    $[14] = setStep;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const onBackClick = t4;
  let t5;
  if ($[16] !== error || $[17] !== isLoadingOtp || $[18] !== isLoadingPassword || $[19] !== onBackClick || $[20] !== onClickForgotPassword || $[21] !== onOtpClick || $[22] !== onSubmitPassword || $[23] !== password) {
    t5 = {
      isLoadingPassword,
      isLoadingOtp,
      password,
      onChangePassword,
      onSubmitPassword,
      onOtpClick,
      error,
      onClickForgotPassword,
      onBackClick
    };
    $[16] = error;
    $[17] = isLoadingOtp;
    $[18] = isLoadingPassword;
    $[19] = onBackClick;
    $[20] = onClickForgotPassword;
    $[21] = onOtpClick;
    $[22] = onSubmitPassword;
    $[23] = password;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  return t5;
};